// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
}

.wrapper {
    max-width: 350px;
    min-height: 490px;
    margin: 80px auto;
    padding: 40px 30px 30px 30px;
    background-color: #EBF4F7;
    border-radius: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-top:1%;
    overflow: auto !important;
}

/* Sesuaikan properti untuk tampilan layar iPad */
@media screen and (min-width: 768px) and (max-width: 1024px) {
    .wrapper {
        margin-top: 40%; /* Sesuaikan sesuai kebutuhan */
    }
}

/* Sesuaikan properti untuk tampilan mobile */
@media screen and (max-width: 767px) {
    .wrapper {
        margin-top: 10%; /* Sesuaikan sesuai kebutuhan */
    }
}

/* Sesuaikan properti untuk tampilan iPhone SE */
@media screen and (max-width: 320px) {
    .wrapper {
        margin-bottom: 150px !important;
        width: 50px !important;
    }
}

.logo {
    width: 90%; /* Make the image take 100% of the container width */
    max-width: 254px; /* Set a maximum width if needed */
    margin: 0 auto; /* Center the image horizontally */
    display: block; /* Ensure the image behaves as a block element */
    object-fit: cover;
}

.logo-tocaa {
    width: 50%;
    height: 130px;
    margin: 0 auto;
    object-fit: cover;
    display: block;
}

.wrapper .name {
    font-weight: 600;
    font-size: 1.4rem;
    letter-spacing: 1.3px;
    padding-left: 10px;
    color: #555;
}

.wrapper .text{
    color: #0000;
    font-family: 'Poppins';
}

.wrapper .form-field input {
    width: 100%;
    height: 34px !important;
    font-size: 12px;
    border-radius: 5px!important;
    color: #666;
    /* border: 1px solid red; */
}

.wrapper .form-field {
    width: 98%;
    margin-right: 40px;
    margin-bottom: 20px;
    border-radius: 16px !important;
}

.wrapper .btn {
    display: inline-block;
    height: 3%;
    margin-top: 12% !important;
    justify-content: center;
    display: flex;
    background-color: #176B87;
    color: #fff;
    border: 2px solid rgb(8, 96, 128);
    border-radius: 6px;
    border: 4px;
    padding: 10px;
    margin: 5px;
    font-size: 12px;
    font-family: 'Poppins';
    font-weight: 900;
    cursor: pointer;
    width: 96%;
}

.wrapper .btn:hover {
    background-color: #d3e1e5;
    color: #b9c7cb;
}

.wrapper a {
    text-decoration: none;
    font-size: 0.8rem;
    color: #03A9F4;
}

.wrapper a:hover {
    color: #039BE5;
}

.tulisan{
    margin-top: 23px;
    margin-bottom: 22px;
    color: #176B87 !important;
    font-size: 11px;
    
}

.nrp-tulisan{
    font-size: 12px !important;
    font-weight: 500 !important;
    color: #176B87 !important;
    font-family: 'Poppins' !important;
    text-align: center !important;
    margin-top: -20px !important
}

.toca-head{
    font-size: 16px !important;
    font-weight: 900 !important;
    color: #009EC5 !important;
    text-align: center;
    font-family: 'Poppins' !important;
    margin-top: 10px !important;
}

.forgotpw {
    font-size: 13px !important;
    font-family: 'Poppins' !important;
    margin-left: 120px;
    margin-top: 100px !important;
    color: #009EC5 !important;
    font-weight: 600;
}

@media (max-width: 800px) {
    .wrapper {
        max-width: 100%;
        margin-top: 150px; /* Adjust as needed */
    }
}

@media only screen and (min-device-width: 767px) and (max-device-width: 1024px) {
    .logo-tocaa {
      width: 50%;
      height: auto;
      margin-left: auto;
      margin-right: auto;
    }
}

@media only screen and (max-width: 767px) {
    .logo-tocaa {
      width: 50%;
      height: auto;
      margin-left: auto;
      margin-right: auto;
    }
}

@media (max-width: 767px) {
    .forgot {
        margin-left: 45%; /* Adjust as needed */
        margin-top: 20px; /* Adjust as needed */
        font-size: 16px; /* Adjust as needed */
    }
    .logo {
        max-width: 100%; /* Adjust the maximum width for smaller screens */
    }
}

.login-toca{
    text-indent: 10px; 
}`, "",{"version":3,"sources":["webpack://./src/components/Signin/Signin.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,yBAAyB;AAC7B;;AAEA,iDAAiD;AACjD;IACI;QACI,eAAe,EAAE,+BAA+B;IACpD;AACJ;;AAEA,6CAA6C;AAC7C;IACI;QACI,eAAe,EAAE,+BAA+B;IACpD;AACJ;;AAEA,gDAAgD;AAChD;IACI;QACI,+BAA+B;QAC/B,sBAAsB;IAC1B;AACJ;;AAEA;IACI,UAAU,EAAE,oDAAoD;IAChE,gBAAgB,EAAE,kCAAkC;IACpD,cAAc,EAAE,kCAAkC;IAClD,cAAc,EAAE,gDAAgD;IAChE,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,4BAA4B;IAC5B,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,0BAA0B;IAC1B,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;;AAEnB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,iCAAiC;IACjC,6BAA6B;IAC7B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB,EAAE,qBAAqB;IAC5C;AACJ;;AAEA;IACI;MACE,UAAU;MACV,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;IACpB;AACJ;;AAEA;IACI;MACE,UAAU;MACV,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB,EAAE,qBAAqB;QACvC,gBAAgB,EAAE,qBAAqB;QACvC,eAAe,EAAE,qBAAqB;IAC1C;IAIA;QACI,eAAe,EAAE,iDAAiD;IACtE;AALJ;;AAQA;IACI,iBAAiB;AACrB","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Poppins', sans-serif;\n}\n\n.wrapper {\n    max-width: 350px;\n    min-height: 490px;\n    margin: 80px auto;\n    padding: 40px 30px 30px 30px;\n    background-color: #EBF4F7;\n    border-radius: 15px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    margin-top:1%;\n    overflow: auto !important;\n}\n\n/* Sesuaikan properti untuk tampilan layar iPad */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n    .wrapper {\n        margin-top: 40%; /* Sesuaikan sesuai kebutuhan */\n    }\n}\n\n/* Sesuaikan properti untuk tampilan mobile */\n@media screen and (max-width: 767px) {\n    .wrapper {\n        margin-top: 10%; /* Sesuaikan sesuai kebutuhan */\n    }\n}\n\n/* Sesuaikan properti untuk tampilan iPhone SE */\n@media screen and (max-width: 320px) {\n    .wrapper {\n        margin-bottom: 150px !important;\n        width: 50px !important;\n    }\n}\n\n.logo {\n    width: 90%; /* Make the image take 100% of the container width */\n    max-width: 254px; /* Set a maximum width if needed */\n    margin: 0 auto; /* Center the image horizontally */\n    display: block; /* Ensure the image behaves as a block element */\n    object-fit: cover;\n}\n\n.logo-tocaa {\n    width: 50%;\n    height: 130px;\n    margin: 0 auto;\n    object-fit: cover;\n    display: block;\n}\n\n.wrapper .name {\n    font-weight: 600;\n    font-size: 1.4rem;\n    letter-spacing: 1.3px;\n    padding-left: 10px;\n    color: #555;\n}\n\n.wrapper .text{\n    color: #0000;\n    font-family: 'Poppins';\n}\n\n.wrapper .form-field input {\n    width: 100%;\n    height: 34px !important;\n    font-size: 12px;\n    border-radius: 5px!important;\n    color: #666;\n    /* border: 1px solid red; */\n}\n\n.wrapper .form-field {\n    width: 98%;\n    margin-right: 40px;\n    margin-bottom: 20px;\n    border-radius: 16px !important;\n}\n\n.wrapper .btn {\n    display: inline-block;\n    height: 3%;\n    margin-top: 12% !important;\n    justify-content: center;\n    display: flex;\n    background-color: #176B87;\n    color: #fff;\n    border: 2px solid rgb(8, 96, 128);\n    border-radius: 6px;\n    border: 4px;\n    padding: 10px;\n    margin: 5px;\n    font-size: 12px;\n    font-family: 'Poppins';\n    font-weight: 900;\n    cursor: pointer;\n    width: 96%;\n}\n\n.wrapper .btn:hover {\n    background-color: #d3e1e5;\n    color: #b9c7cb;\n}\n\n.wrapper a {\n    text-decoration: none;\n    font-size: 0.8rem;\n    color: #03A9F4;\n}\n\n.wrapper a:hover {\n    color: #039BE5;\n}\n\n.tulisan{\n    margin-top: 23px;\n    margin-bottom: 22px;\n    color: #176B87 !important;\n    font-size: 11px;\n    \n}\n\n.nrp-tulisan{\n    font-size: 12px !important;\n    font-weight: 500 !important;\n    color: #176B87 !important;\n    font-family: 'Poppins' !important;\n    text-align: center !important;\n    margin-top: -20px !important\n}\n\n.toca-head{\n    font-size: 16px !important;\n    font-weight: 900 !important;\n    color: #009EC5 !important;\n    text-align: center;\n    font-family: 'Poppins' !important;\n    margin-top: 10px !important;\n}\n\n.forgotpw {\n    font-size: 13px !important;\n    font-family: 'Poppins' !important;\n    margin-left: 120px;\n    margin-top: 100px !important;\n    color: #009EC5 !important;\n    font-weight: 600;\n}\n\n@media (max-width: 800px) {\n    .wrapper {\n        max-width: 100%;\n        margin-top: 150px; /* Adjust as needed */\n    }\n}\n\n@media only screen and (min-device-width: 767px) and (max-device-width: 1024px) {\n    .logo-tocaa {\n      width: 50%;\n      height: auto;\n      margin-left: auto;\n      margin-right: auto;\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .logo-tocaa {\n      width: 50%;\n      height: auto;\n      margin-left: auto;\n      margin-right: auto;\n    }\n}\n\n@media (max-width: 767px) {\n    .forgot {\n        margin-left: 45%; /* Adjust as needed */\n        margin-top: 20px; /* Adjust as needed */\n        font-size: 16px; /* Adjust as needed */\n    }\n}\n\n@media (max-width: 767px) {\n    .logo {\n        max-width: 100%; /* Adjust the maximum width for smaller screens */\n    }\n}\n\n.login-toca{\n    text-indent: 10px; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
